<template>
    <div class="security">
        <van-tabs>
            <van-tab title="修改密码">
				<div class="icode-phone-box">
					<span class="phone-icon"></span>
					<form>
						<input
							class="login-input" 
							placeholder="请输入11位手机号"
							v-model="passWordResetForm.phone"
							@blur="registerPhoneNumCheck"
						/>
					</form>
				</div>
				<span class="error-message">{{registerPhoneError}}</span>
				<div class="icode-box">
					<span class="icode-icon"></span>
					<form>
						<input
							class="login-input"
							placeholder="请输入6位验证码"
							v-model="passWordResetForm.code"
							@blur="registerIdentCodeCheck"
						/>
					</form>
					<van-button :disabled="identCodeDisabled" @click="getIdentCode"><span v-if="reIndentCodeText">重新</span>获取验证码<span v-if="reIndentCodeNum">{{countdown}}</span></van-button>
				</div>
				<span class="error-message">{{registerIndentError}}</span>
				<div class="psw-box" v-if="this.$route.meta.title!=='bindphone'">
					<span class="password-icon"></span>
					<form>
						<input
						class="login-input"
						type="password"
						placeholder="请输入密码"
						v-model="passWordResetForm.password"
						@blur="registerPswCheck"
						/>
					</form>
				</div>
				<span class="error-message">{{registerPswError}}</span>
				<div class="repsw-box" v-if="this.$route.meta.title!=='bindphone'">
					<span class="password-icon"></span>
					<form>
						<input
						class="login-input"
						type="password"
						placeholder="请再次输入密码"
						v-model="passWordResetForm.repassword"
						@blur="registerRePswCheck"
						/>
					</form>
				</div>
				<span class="error-message">{{registerRePswError}}</span>
				<button :class="{'pswset-submit':true,'btn-submiting':Btnsubmiting}" @click="submitPswResetForm" ref="pswSubmitBtn">确定</button>
			</van-tab>
            <van-tab title="修改手机号">
                <p class="input-tag">原手机号</p>
                <div class="icode-phone-box">
                    <span class="phone-icon"></span>
                    <input
                        class="login-input"
                        v-model="telResetForm.old_phone"
                        placeholder="请输入11位手机号"
						@blur="telResetPhoneNumCheck"
                    />
                </div>
				<span class="error-message">{{icodePhoneError}}</span>
                <p class="input-tag">新手机号</p>
                <div class="icode-phone-box">
                    <span class="phone-icon"></span>
                    <input
                        class="login-input"
                        v-model="telResetForm.new_phone"
                        placeholder="请输入11位手机号"
						@blur="telResetRePhoneNumCheck"
                    />
                </div>
				<span class="error-message">{{icodeRePhoneError}}</span>
                <p class="input-tag">验证码</p>
                <div class="icode-box">
                    <span class="icode-icon"></span>
                    <input
                        class="login-input"
                        v-model="telResetForm.code"
                        placeholder="请输入6位验证码"
						@blur="telResetIdentCodeCheck"
                    />
                    <van-button :disabled="phoneResetIdentCodeDisabled" @click="telResetGetIdentCode"><span v-if="phoneResetReIndentCodeText">重新</span>获取验证码<span v-if="phoneResetReIndentCodeNum">{{phoneResetCountdown}}</span></van-button>
                </div>
				<span class="error-message">{{icodeError}}</span>
                <p class="input-tag">原密码</p>
                <div class="login-password-box">
                    <span class="password-icon"></span>
                    <input
                        class="login-input"
                        v-model="telResetForm.password"
                        type="password"
                        placeholder="请输入密码"
						@blur="telResetPswCheck"
                    />
                </div>
				<span class="error-message">{{icodePassWordError}}</span>
                <button :disabled="telResetDisabled" :class="{'login-submit':true,'btn-submiting':telResetsubmiting}" @click="submitTelResetForm" ref="telResetBtn">确定</button>
            </van-tab>
        </van-tabs>
        <router-view/>
    </div>
</template>
<script>
import HeaderNav from '@/components/HeaderNav.vue'
import {phoneNumCheck,identCodeCheck} from '@/assets/api/validate'
import {GetCookie,DelCookie} from '@/assets/api/cookie'
import {AxiosOld} from '@/assets/api/axios'
import {AxiosOldByToken} from '@/assets/api/axios'
import notifyIcon from '@/assets/img/msgicon.png'
export default {
	name: 'security',
	data(){
		return{
			timer:'',                           //修改密码重新获取验证码倒计时
			Btnsubmiting:false,                 //修改密码表单提交中按钮样式
			reIndentCodeText:false,             //修改密码显示重新获取验证码汉字
			reIndentCodeNum:false,              //修改密码显示重新获取和验证码倒计时数字
			identCodeDisabled:true,             //修改面控制获取验证码按钮可点击状态
			countdown:30,                       //修改密码重新获取验证码倒计时
			submitBtnDisabled:false,            //修改密码控制提交按钮防止重复提交表单      

			registerPhoneError:'',              //修改密码时手机号码出错
			registerIndentError:'',             //修改密码时填写的验证码不足6位
			registerPswError:'',                //修改密码输入密码错误提示
			registerRePswError:'',              //修改密码输入密码错误提示
			passWordResetForm: {                //修改密码表单提交
				phone:'',
				code:'',
				password: '',
				repassword: '',
			},

			telResetForm:{                       //修改手机号表单
				old_phone:'',
				new_phone:'',
				code:'',
				password:''
			},

			phoneResetTimer:'',                           //修改手机号重新获取验证码倒计时
			phoneResetBtnsubmiting:false,                 //修改手机号表单提交中按钮样式
			phoneResetReIndentCodeText:false,             //修改手机号显示重新获取验证码汉字
			phoneResetReIndentCodeNum:false,              //修改手机号显示重新获取和验证码倒计时数字
			phoneResetIdentCodeDisabled:true,             //修改手机号制获取验证码按钮可点击状态
			phoneResetCountdown:30,                       //修改手机号重新获取验证码倒计时
			phoneResetSubmitBtnDisabled:false,            //修改手机号控制提交按钮防止重复提交表单
			telResetsubmiting:false,                      //修改手机号表单提交时按钮样式
			telResetDisabled:false,                       //修改手机号表单提交按钮禁用状态
			
			icodePhoneError:'',                 //修改手机号手机号错误信息提示
			icodeRePhoneError:'',               //修改手机号再次输入手机错误信息提示
			icodeError:'',                      //修改手机号验证码错误信息提示
			icodePassWordError:''               //修改手机号密码错误信息提示

			
		}
	},
	created(){
	},
	watch:{
		//监听修改密码表单手机号输入
		"passWordResetForm.phone":function(){
			if(this.passWordResetForm.phone.lenght!==11){
				this.identCodeDisabled=true
			}
			if(this.passWordResetForm.phone.length===11){
				AxiosOld.get("/phone/info",{params:{"phone":this.passWordResetForm.phone}})
				.then(
					response=>{
						if(response.data.data===0){
							this.identCodeDisabled=true
							this.registerPhoneError="该手机号未注册"
						}
						else if(response.data.data===1){
							this.identCodeDisabled=false
							this.registerPhoneError=""
						}
					}
				)
			}
		},
		//重新获取验证码倒计时显示
		countdown:function(){
			if(this.countdown<=0){
				clearInterval(this.timer)
				this.reIndentCodeNum=false
				this.identCodeDisabled=false
				this.countdown=30
			}
		},
		//监听修改手机号旧手机号输入
		"telResetForm.old_phone":function(val){
			if(val.length!==11){
				this.phoneResetIdentCodeDisabled=true
			}
			if(val.length==11){
				AxiosOld.get("/phone/info",{params:{"phone":val}})
				.then(
					response=>{
						if(response.data.data===0){
							this.icodePhoneError="该手机号未注册"
						}
						else if(response.data.data===1){
							this.icodePhoneError=""
							if(this.telResetForm.new_phone!==""&&!this.icodeRePhoneError){
								this.phoneResetIdentCodeDisabled=false
							}
						}
					}
				)
			}
		},
		//监听修改手机号旧手机号输入
		"telResetForm.new_phone":function(val){
			if(val.length!==11){
				this.phoneResetIdentCodeDisabled=true
			}
			if(val.length==11){
				AxiosOld.get("/phone/info",{params:{"phone":val}})
				.then(
					response=>{
						if(response.data.data===0){
							this.icodeRePhoneError=""
							if(this.telResetForm.old_phone!==""&&!this.icodePhoneError){
								this.phoneResetIdentCodeDisabled=false
							}
						}
						else if(response.data.data===1){
							this.icodeRePhoneError="该手机号已注册"
						}
					}
				)
			}
		},
		//监听修改手机号验证码倒计时
		phoneResetCountdown:function(val){
			if(val<=0){
				clearInterval(this.phoneResetTimer)
				this.phoneResetIdentCodeDisabled=false
				this.phoneResetReIndentCodeNum=false
				this.phoneResetCountdown=30
			}
		}
	},
	methods:{
		//修改密码表单手机号码验证
		registerPhoneNumCheck(){
			if(!phoneNumCheck(this.passWordResetForm.phone)){
				this.registerPhoneError="请输入正确手机号"
				this.identCodeDisabled=true
				return false
			}else{
				return true
			}
		},
		//修改密码表单验证码验证
		registerIdentCodeCheck(){
			if(identCodeCheck(this.passWordResetForm.code)){
				this.registerIndentError=""
				return true
			}else{
				this.registerIndentError="请输入正确验证码"
				return false
			}
		},
		//修改密码表单密码验证
		registerPswCheck(){
			if(this.passWordResetForm.password==""&&this.passWordResetForm.repassword==""){
				this.registerPswError="请输入密码"
				return false
			}else{
				this.registerPswError=""
				return true
			}
		},
		//修改密码表单再次输入密码验证
		registerRePswCheck(){
			if(this.passWordResetForm.repassword==""){
				this.registerRePswError="请再次输入密码"
				return false
			}else{
				this.registerRePswError=""
				return true
			}
		},
		//修改密码表单获取验证码
		getIdentCode(){
			AxiosOld.post('sendsms',{"phone":this.passWordResetForm.phone,"login":1})
			.then(
				response=>{
					if(response.data.code==200&&response.data.status==='success'){
						this.identCodeDisabled=true;
						this.reIndentCodeText=true;
						this.reIndentCodeNum=true;
						this.timer=setInterval(()=>{
							this.countdown-=1;
						},1000)
					}
				}
			)
			.catch(
				error=>{
					this.$swal({
						text:'网络错误 请稍后重试',
						showConfirmButton:false,
						width:'6rem',
						padding:'0.5rem',
						timer:1200,
						imageWidth:50,
						imageHeight:50,
						imageUrl:notifyIcon,
						timerProgressBar: true
					});
				}
			)
		},
		//修改密码表单提交
		submitPswResetForm(){
			AxiosOldByToken.defaults.headers.common['Authorization']=GetCookie('token')
			this.registerPhoneNumCheck()
			this.registerIdentCodeCheck()
			this.registerPswCheck()
			this.registerRePswCheck()
			if(this.passWordResetForm.password!==this.passWordResetForm.repassword){
				this.registerPswError=this.registerRePswError="两次输入密码不一致"
				return false
			}
			let validateRes=!this.registerPhoneError&&!this.registerIndentError&&!this.registerPswError&&!this.registerRePswError
			if(validateRes){
				this.Btnsubmiting=true
				this.submitBtnDisabled=true
				this.$refs.pswSubmitBtn.innerHTML="提交中..."
				AxiosOldByToken.post('editpwd',this.passWordResetForm).then(
					response=>{
						if(response.data.data.errcode==1000&&response.data.code==200){
						this.Btnsubmiting=false
						this.submitBtnDisabled=false
						this.$refs.pswSubmitBtn.innerHTML="确定"
						this.registerIndentError="验证码错误"
						}
						else if(response.data.data.errcode==1001&&response.data.code==200){
						this.Btnsubmiting=false
						this.submitBtnDisabled=false
						this.$refs.pswSubmitBtn.innerHTML="确定"
						this.registerIndentError="验证码错误"
						}else{
						//密码修改成功后跳转到登录页
							DelCookie('token')
							DelCookie('phone')
							DelCookie('real_auth')
							DelCookie('pn')
							this.Btnsubmiting=false
							this.submitBtnDisabled=false
							this.$refs.pswSubmitBtn.innerHTML="确定"
							this.$swal({
								text:'密码修改成功 请重新登录',
								showConfirmButton:false,
								width:'6rem',
								padding:'0.5rem',
								timer:1200,
								imageWidth:50,
								imageHeight:50,
								imageUrl:notifyIcon,
								timerProgressBar: true
							});
							setTimeout(()=>{
								location.href='/login'
							},1200)
						}
					}
				)
				.catch(
					error=>{
						this.Btnsubmiting=false
						this.submitBtnDisabled=false
						this.$refs.pswSubmitBtn.innerHTML="确定"
						this.$swal({
							text:'网络错误 请稍后重试',
							showConfirmButton:false,
							width:'6rem',
							padding:'0.5rem',
							timer:1200,
							imageWidth:50,
							imageHeight:50,
							imageUrl:notifyIcon,
							timerProgressBar: true
						})
					}
				)
			}
		},

		//修改手机表单手机号验证
		telResetPhoneNumCheck(){
			if(!phoneNumCheck(this.telResetForm.old_phone)){
				this.icodePhoneError="请输入正确手机号"
				return false
			}else{
				return true
			}
		},
		//修改手机表单再次输入手机号验证
		telResetRePhoneNumCheck(){
			if(!phoneNumCheck(this.telResetForm.new_phone)){
				this.icodeRePhoneError="请输入正确手机号"
				return false
			}else{
				return true
			}
		},
		//修改手机表单验证码验证
		telResetIdentCodeCheck(){
			if(identCodeCheck(this.telResetForm.code)){
				this.icodeError=""
				return true
			}else{
				this.icodeError="请输入正确验证码"
				return false
			}
		},
		//修改手机表单密码验证
		telResetPswCheck(){
			if(this.telResetForm.password==""){
				this.icodePassWordError="请输入密码"
				return false
			}else{
				this.icodePassWordError=""
				return true
			}
		},
		//修改手机获取验证码
		telResetGetIdentCode(){
			AxiosOld.post('sendsms',{"phone":this.telResetForm.new_phone,"old_phone":this.telResetForm.old_phone,"edit_phone":1})
			.then(
				response=>{
					this.phoneResetIdentCodeDisabled=true;
					this.phoneResetReIndentCodeText=true;
					this.phoneResetReIndentCodeNum=true;
					this.phoneResetTimer=setInterval(()=>{
						this.phoneResetCountdown-=1;
					},1000)
				}
			).catch(
				error=>{
					console.log(error)
				}
			)
		},
		//提交修改手机号表单
		submitTelResetForm(){
			AxiosOldByToken.defaults.headers.common['Authorization']=GetCookie('token')
			this.telResetRePhoneNumCheck()
			this.telResetIdentCodeCheck()
			this.telResetIdentCodeCheck()
			this.telResetPswCheck()
			let validateRes=!this.icodePhoneError&&!this.icodeRePhoneError&&!this.icodeError&&!this.icodePassWordError
			if(validateRes){
				this.telResetsubmiting=true
				this.telResetDisabled=true
				this.$refs.telResetBtn.innerHTML="提交中..."
				AxiosOldByToken.post('editphone',this.telResetForm)
				.then(
					response=>{
						if(response.data.data.errcode==1000&&response.data.code==200){
							this.telResetsubmiting=false
							this.telResetDisabled=false
							this.$refs.telResetBtn.innerHTML="确定"
							this.icodeError="验证码错误"
						}else if(response.data.data.errcode==1001&&response.data.code==200){
							this.telResetsubmiting=false
							this.telResetDisabled=false
							this.$refs.telResetBtn.innerHTML="确定"
							this.icodeError="验证码错误"
						}else{
							this.telResetsubmiting=false
							this.telResetDisabled=false
							this.$refs.telResetBtn.innerHTML="确定"
							DelCookie('token')
							DelCookie('phone')
							DelCookie('real_auth')
							DelCookie('pn')
							this.$swal({
								text:'手机号修改成功 请重新登录',
								showConfirmButton:false,
								width:'6rem',
								padding:'0.5rem',
								timer:1200,
								imageWidth:50,
								imageHeight:50,
								imageUrl:notifyIcon,
								timerProgressBar: true
							});
							setTimeout(()=>{
								location.href='/login'
							},1200)
						}
					}
				).catch(
					error=>{
						this.telResetsubmiting=false
						this.telResetDisabled=false
						this.$refs.telResetBtn.innerHTML="确定"
						this.$swal({
							text:'网络错误 请稍后重试',
							showConfirmButton:false,
							width:'6rem',
							padding:'0.5rem',
							timer:1200,
							imageWidth:50,
							imageHeight:50,
							imageUrl:notifyIcon,
							timerProgressBar: true
						})
					}
				)
			}
		}
	}
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.security{
    padding:80px;
    padding-top:180px;
}
.input-tag{
    font-size:24px;
    color:#222;
    margin-bottom:30px;
    padding-left:8px;
}
input::-webkit-input-placeholder{
    color: #ccc !important;
	line-height:30px;
}
//TAb下换线和字体样式修改开始
.van-tabs--line .van-tabs__wrap{
    height:60px !important;
    margin-bottom:60px !important;
}
.van-tab__text{
    font-size:28px !important;
    color:#302D2D;
}
.van-tab--active{
    .van-tab__text{
        font-size:30px !important;
        color:#222;
        font-weight:bold;
    }
}
.van-tabs__line{
    width:30px !important;
    background-color:#bf0000 !important;
    height:6px;
}
.error-message{
    color:#bf0000;
    padding-left:20px;
    font-size:20px;
    height:20px;
    display:block;
	padding-top:6px;
	margin-bottom:20px;
}
//TAb下换线和字体样式修改结束

//输入框样式修改开始
.van-tabs__wrap{
    margin-bottom:40px;
}
.van-cell{
    margin-bottom:30px;
}
.login-phone-box,.login-password-box,.psw-box,.repsw-box{
    position:relative;
    .phone-icon,.password-icon{
        display:inline-block;
        background:red;
        position:absolute;
        top:50%;
		left:24px;
		transform:translateY(-15px);
    }
    .phone-icon{
        width:22px;
		height:26px;
        background:url('../assets/img/phoneicon.png') no-repeat;
        background-size:100% 100%;
    }
    .password-icon{
        width:26px;
		height:26px;
        background:url('../assets/img/pswicon.png') no-repeat;
        background-size:100% 100%;
    }
}
.pswset-submit{
    width:586px;
    height:70px;
    line-height:70px;
    text-align:center;
    color:#fff;
    font-size:24px;
    background:#bf0000;
    border-radius:35px;
	border:none;
}
.pswset-submit:active{
    background:#DD8386;  
}
//输入框样式修改结束

//手机号登录表单样式开始
.icode-phone-box{
    @extend .login-phone-box;
}
.icode-box{
    position:relative;
    .icode-icon{
        display:inline-block;
        background:red;
        position:absolute;
        top:50%;
        left:24px;
        transform:translateY(-15px);
        width:26px;
        height:29px;
        background:url('../assets/img/icodeicon.png') no-repeat;
        background-size:100% 100%;
    }
    .van-button{
        position:absolute;
        right:20px;
        top:18px;
        color:#bf0000;
        background:rgba(247,247,247,1);
        border:none;
        font-size:22px;
    }
}
//手机号登录表单样式结束
</style>